import { useId as reactUseId } from 'react';

/**
 * A stable DOM id, preferring one the caller supplied.
 *
 * Every form control in this library binds a real `<label for>` to a real input id.
 * That is not decoration: a placeholder is not a label, and a screen reader user
 * filling in a fee agreement needs to know which field they are in.
 */
export function useFieldId(provided?: string): string {
  const generated = reactUseId();
  return provided ?? generated;
}
